import { CookieHelper } from 'Utils/cookieHelper'
import { getUrlParam } from 'Utils/routes'
import { VerifyInviteResponse, useVerifyUrlCode } from '../api/verifyUrlCode'

export const useVerifyUrlCodeFromParams = () => {
  const { setCookie } = CookieHelper()
  const { mutate } = useVerifyUrlCode()

  const getUrlCode = () => getUrlParam('code')

  const verifyUrlCode = (userId: number, callBack?: (data: VerifyInviteResponse) => void) => {
    const code = getUrlCode()
    if (code)
      mutate(
        { code, userId },
        {
          onSuccess(data) {
            if (data && !(data instanceof Error) && callBack) callBack(data)
          },
        }
      )
  }

  const getParamsFromURL = () => {
    const params = new URL(window.location.href).search
    const paramsString = Object.fromEntries(new URLSearchParams(params))

    if (Object.keys(paramsString).length === 0) {
      // If the string of params is an empty object, return
      return
    } else {
      // If there are params, iterate over the params string and save each key-value pair into the session storage
      Object.keys(paramsString).forEach((param) => {
        sessionStorage.setItem(param, paramsString[param])

        if (param === 'cxd') {
          //720 - the cxd cookie needs to expire in 30 days. 30 days x 24 hours per day is 720
          const cookieOptions = { expires: 720, secure: true }
          setCookie(param, paramsString[param], cookieOptions)
        }
      })
    }
  }

  const getSessionStorageItemForSessionIdentifier = (itemName: string) => {
    const params = new URL(window.location.href).search
    if (!params.includes(itemName)) {
      return
    } else {
      return sessionStorage.getItem(itemName)
    }
  }

  const getSessionStorageItem = (itemName: string) => {
    return sessionStorage.getItem(itemName)
  }

  return {
    verifyUrlCode,
    getUrlCode,
    getParamsFromURL,
    getSessionStorageItemForSessionIdentifier,
    getSessionStorageItem,
  }
}
